// export const header = {
// 	Accept: "application/json",
// 	"Content-Type": "application/json",
// 	// Accept: "*",
// 	"Access-Control-Allow-Origin": "*",
// };

export const header = {
	Accept: "application/json",
	"Content-Type": "multipart/form-data",
	// Accept: "*",
	"Access-Control-Allow-Origin": "*",
};

export const header2 = {
	"Content-Type": "multipart/form-data",
	Accept: "application/json",
	"Access-Control-Allow-Origin": "*",
};

